import React from 'react'
import { Link } from 'react-router-dom'

function PendingPage() {
  return (
    <div className="text-center space-y-6">
      <div>
        <h2 className="mt-2 text-2xl font-bold text-gray-900">Tu cuenta está en aprobación</h2>
        <p className="mt-2 text-sm text-gray-600">Hemos creado tu cuenta y está pendiente de aprobación por el administrador.</p>
        <p className="text-sm text-gray-600">Te avisaremos cuando esté lista para usar Dkard.</p>
      </div>
      <div>
        <Link to="/auth/login" className="btn-primary">Ir a Iniciar sesión</Link>
      </div>
    </div>
  )
}

export default PendingPage
